import { Reducer } from 'redux';
import { createReducer } from 'redux-act';

import { TopicsActions } from './topics.actions';
import { TopicsState } from './topics.types';

const initialState: TopicsState = {
};

export const topics = createReducer(
  (on) => {
    on(TopicsActions.selectTopic, (state, payload) => ({ ...state, selectedTopic: payload }));

    on(TopicsActions.closeTopic, (state) => ({ ...state, selectedTopic: undefined }));
  },
  initialState,
) as Reducer<TopicsState>;
